import styled from 'styled-components';
export const Container = styled.div `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: nowrap;
`;
